
export default function HighlightImageHandler({ src, gridcols, gridrows, altText, desc }) {

  return (
    <div className={`showcase-image-container grid-col-span-${gridcols} grid-row-span-${gridrows}`}><img tabIndex='0' className='showcase-image' srcSet={src} alt={altText} data-desc={desc}/> </div>
     
  )
}
